const words = ["ag-grid", "ag grid", "*".repeat(10)];
// eslint-disable-next-line no-console
const consoleError = console.error;
// eslint-disable-next-line no-console
console.error = (...args) => {
  if (
    args.some((arg) =>
      words.some((word) => String(arg).toLowerCase().includes(word)),
    )
  ) {
    if (import.meta.env.DEV) {
      // eslint-disable-next-line no-console
      console.debug(...args);
    }
    return;
  }
  consoleError(...args);
};
